import { IonButton, IonIcon, IonSkeletonText, IonText } from "@ionic/react";
import { useTranslation } from "react-i18next";
import { useQuery } from "@tanstack/react-query";
import { REQUIRED_CORE_VALUE_ACCURACY_TO_CHOOSE_CORE_VALUES } from "@/lib/constants";
import { arrowRightIcon } from "@/lib/icons/@heroicons/react/16/solid";
import { queryOptions_coreValuesChosen } from "@/lib/query/functions/core-values/chosen";
import { useMyProgression } from "@/lib/query/functions/user/progression";
import { Routes } from "@/lib/router";

export function ChooseCoreValuesWidget() {
	const { t } = useTranslation();
	const { data, isLoading } = useQuery(queryOptions_coreValuesChosen());
	const [myProgression] = useMyProgression();

	if (isLoading) {
		return <IonSkeletonText animated className="h-42 rounded-3xl" />;
	}

	if (
		(data?.length && data.length > 0) ||
		myProgression.core_value_accuracy < REQUIRED_CORE_VALUE_ACCURACY_TO_CHOOSE_CORE_VALUES
	) {
		return <></>;
	}

	return (
		<div className="bg-brown-100 flex flex-col gap-2 rounded-3xl p-4">
			<IonText className="text-brown-700 text-2xl font-bold">
				{t("widgets.choose-core-values.title")}
			</IonText>
			<IonText className="text-brown-600">{t("widgets.choose-core-values.description")}</IonText>

			<IonButton
				className="ion-py-2.5 ion-rounded-lg min-h-10"
				routerLink={Routes.CoreValuesSort()}
			>
				{t("widgets.choose-core-values.action")}
				<IonIcon slot="end" icon={arrowRightIcon} className="ml-2 size-5 opacity-60" />
			</IonButton>
		</div>
	);
}
